/**
 * @generated SignedSource<<064653041bd44bd7b8f928ae9af3dcfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
export type AssignDraftPackageToMemberInput = {
  assignmentOptions?: PackageAssignmentOptionsInput | null | undefined;
  memberId: string;
  packageId: string;
};
export type PackageAssignmentOptionsInput = {
  billingResetDayOverride?: number | null | undefined;
  endsOn?: string | null | undefined;
  firstBillingOn?: string | null | undefined;
  startsOn?: string | null | undefined;
  waiveInitialFee?: boolean | null | undefined;
};
export type useAssignDraftMemberPackageMutation$variables = {
  input: AssignDraftPackageToMemberInput;
};
export type useAssignDraftMemberPackageMutation$data = {
  readonly assignDraftPackageToMember: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly memberPackage: {
      readonly id: string;
      readonly orders: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly packageDueDate: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly package: {
        readonly billingType: PackageBillingType;
      };
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useAssignDraftMemberPackageMutation = {
  response: useAssignDraftMemberPackageMutation$data;
  variables: useAssignDraftMemberPackageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderConnection",
  "kind": "LinkedField",
  "name": "orders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Order",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "packageDueDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v8 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAssignDraftMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignDraftPackageToMemberPayload",
        "kind": "LinkedField",
        "name": "assignDraftPackageToMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberPackage",
            "kind": "LinkedField",
            "name": "memberPackage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAssignDraftMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignDraftPackageToMemberPayload",
        "kind": "LinkedField",
        "name": "assignDraftPackageToMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberPackage",
            "kind": "LinkedField",
            "name": "memberPackage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a44c7846ab1203eef2bf377a4a8ec11d",
    "id": null,
    "metadata": {},
    "name": "useAssignDraftMemberPackageMutation",
    "operationKind": "mutation",
    "text": "mutation useAssignDraftMemberPackageMutation(\n  $input: AssignDraftPackageToMemberInput!\n) {\n  assignDraftPackageToMember(input: $input) {\n    memberPackage {\n      id\n      orders {\n        edges {\n          node {\n            id\n            packageDueDate\n          }\n        }\n      }\n      package {\n        __typename\n        billingType\n        id\n      }\n    }\n    success\n    errors {\n      __typename\n      code\n      field\n      message: code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8192e8c26213430abe46b233de7747eb";

export default node;
